export function PerformancesTargetSkeleton() {
  return (
    <div className="pt-10 p-7">
      <div className="h-10 mb-10 rounded-full w-60 animate-pulse bg-muted md:h-12 md:w-80 lg:mb-16 lg:h-16 lg:w-96" />
      <div className="flex flex-wrap space-x-0 space-y-7 lg:flex-nowrap lg:space-x-7 lg:space-y-0">
        <div className="flex flex-col w-full lg:w-6/12 h-96 animate-pulse rounded-xl bg-muted" />
        <div className="flex flex-col w-full lg:w-6/12 h-96 animate-pulse rounded-xl bg-muted" />
      </div>
      <div className="flex flex-wrap space-x-0 mt-7 space-y-7 lg:flex-nowrap lg:space-x-7 lg:space-y-0">
        <div className="flex flex-col w-full lg:w-4/12 h-96 animate-pulse rounded-xl bg-muted" />
        <div className="flex flex-col w-full lg:w-8/12 h-96 animate-pulse rounded-xl bg-muted" />
      </div>
    </div>
  );
}
